<template>
  <div class="page">
    <h3>API 조회 - Cafe24 호출</h3>
    <p class="desc">Cafe24 API 를 호출해서 결과를 얻고, 호출 및 결과를 json 형태로 확인 할 수 있다.</p>

    <div class="form">
      <div class="field">
        <label>id(로그인ID)</label>
        <input v-model="form.memberId" type="text" placeholder="로그인ID" />
      </div>
      <div class="field">
        <label>주문번호</label>
        <input v-model="form.orderNo" type="text" placeholder="주문번호" />
      </div>
      <div class="field">
        <label>시작날짜</label>
        <input v-model="form.startDate" type="date" />
      </div>
      <div class="field">
        <label>종료날짜</label>
        <input v-model="form.endDate" type="date" />
      </div>
    </div>

    <div class="btns">
      <button class="primary" :disabled="loading" @click="queryOrders">주문 조회</button>
      <button class="primary" :disabled="loading" @click="queryRefunds">환불 조회</button>
      <button class="primary" :disabled="loading" @click="queryOrdersTest">주문 테스트 조회</button>
      <span v-if="loading" class="loading">호출 중...</span>
    </div>

    <div v-if="requestInfo" class="result">
      <h4>호출 정보</h4>
      <pre class="json">{{ requestInfo }}</pre>
    </div>

    <div v-if="resultText" class="result">
      <h4>결과 (JSON)</h4>
      <pre class="json">{{ resultText }}</pre>
    </div>

    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import api from '../api';

export default {
  name: 'ApiConsole',
  data() {
    return {
      form: { memberId: '', orderNo: '', startDate: '', endDate: '' },
      loading: false,
      requestInfo: '',
      resultText: '',
      error: ''
    };
  },
  methods: {
    params() {
      return {
        memberId: this.form.memberId,
        order_id: this.form.orderNo,
        startDate: this.form.startDate,
        endDate: this.form.endDate
      };
    },
    // 결과 문자열을 보기좋게 처리: JSON 이면 파싱 후 pretty, 아니면 원문 그대로
    prettify(data) {
      if (data == null) return '';
      if (typeof data === 'object') {
        return JSON.stringify(data, null, 2);
      }
      if (typeof data === 'string') {
        try {
          return JSON.stringify(JSON.parse(data), null, 2);
        } catch (e) {
          return data; // 일반 메시지(미연동 등)
        }
      }
      return String(data);
    },
    async call(type, apiFn) {
      this.loading = true;
      this.error = '';
      this.resultText = '';
      const params = this.params();
      this.requestInfo = JSON.stringify(
        { function: type, method: 'GET', params },
        null,
        2
      );
      try {
        const res = await apiFn(params);
        // 응답 인터셉터가 ApiResponse 를 언랩 → res.data 는 원문 JSON 문자열 또는 메시지
        this.resultText = this.prettify(res && res.data !== undefined ? res.data : res);
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    queryOrders() {
      this.call('주문 조회 (1개 id의 주문 건들)', api.cafe24QueryOrders);
    },
    queryRefunds() {
      this.call('환불 조회 (1개 id의 환불 건들)', api.cafe24QueryRefunds);
    },
    queryOrdersTest() {
      this.call('주문 테스트 조회 (embed=refunds)', api.cafe24QueryOrdersTest);
    }
  }
};
</script>

<style scoped>
.page { background: #fff; padding: 20px; border-radius: 8px; }
h3 { margin: 0 0 6px; }
.desc { color: #667; font-size: 13px; margin: 0 0 16px; }
.form { display: flex; flex-wrap: wrap; gap: 14px; margin-bottom: 14px; }
.field { display: flex; flex-direction: column; gap: 4px; }
.field label { font-size: 12px; color: #33415c; }
.field input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; min-width: 160px; }
.btns { display: flex; gap: 8px; align-items: center; margin-bottom: 16px; }
.btns .primary { padding: 8px 18px; background: #2f6fed; color: #fff; border: none; border-radius: 5px; cursor: pointer; }
.btns .primary:disabled { background: #9db8ef; cursor: default; }
.btns .loading { font-size: 13px; color: #2f6fed; }
.result { margin-top: 16px; }
.result h4 { margin: 0 0 6px; font-size: 14px; color: #33415c; }
.json { background: #0f172a; color: #d5e3ff; padding: 14px; border-radius: 6px; font-size: 12.5px; line-height: 1.5; overflow: auto; max-height: 480px; white-space: pre-wrap; word-break: break-all; }
.error { font-size: 13px; color: #d93636; background: #fdf0f0; padding: 8px 10px; border-radius: 6px; margin-top: 12px; }
</style>
